/**
 * Partner referral for signup (Numok partner program).
 *
 * public/index.html stores the first referral it sees (?via= / ?ref=) in the
 * sp_ref cookie, shared across *.storkplus.com, so a partner link that landed on
 * storkplus.com still counts here. A ref on this page's own URL is the fallback.
 * Returns { affiliateRef, affiliateRefAt } or {} when there is none.
 */
const REF_PATTERN = /^[A-Za-z0-9_-]{1,50}$/;

export function getReferral() {
  const match = document.cookie.match(/(?:^|; )sp_ref=([^;]*)/);

  if (match) {
    try {
      const data = JSON.parse(decodeURIComponent(match[1]));

      if (REF_PATTERN.test(data.c || "")) {
        return { affiliateRef: data.c, affiliateRefAt: Number(data.t) || Date.now() };
      }
    } catch (e) {
      // A malformed cookie is ignored, not an error for the signup.
    }
  }

  const params = new URLSearchParams(window.location.search);
  const code = params.get("via") || params.get("ref");

  return code && REF_PATTERN.test(code) ? { affiliateRef: code, affiliateRefAt: Date.now() } : {};
}
